import { currentPage } from '../common/layout';
import { getCBSWidget } from '../common/shop/cbs-widget-loader';
import 'jquery-scrolltie';
import m1FindVehicleEu from '../common/shop/m1-find-vehicle-eu';
import m1FindVehicleUs from '../common/shop/m1-find-vehicle-us';
import m1FindVehicleByType from '../common/shop/m1-find-vehicle-by-type';
import '../common/jquery-snap-scroll';
import '../common/jquery.sticky';
// import '../common/lazyload.picture';

currentPage.pageInit = ($page, pageData, pageId) => {
    let currentEdition = document.querySelector('body').dataset.edtn;
    //bigImgLazyload();
    $('.sidebar').stickySidebar({ containerSelector: '.content-area' });
    $('.ss-slider').snapScrollControll();     

    var $img = $('.reload img.m1-cse-item_image');

    if ($img.length > 0) {
        var qLenght = $img.length - 1;
        $(window).on('load', function(){
            $img.each(function(i, q) {
                if (i === qLenght && $img[qLenght].complete){
                    $('.reload .msnt-items-slider_slide').css('height','100%');
                    return false;
                }
            });
        })
    }

	$('#top_box .item .poster').scrollTie({
	    property: 'translateY',
        delay: function(el){
        	return 350;
        },
	    stopAtValue: document.documentElement.clientHeight,
	    speed: isTouch ? 0.15 : 0.3
    });
    
    let previews = document.querySelectorAll('.item.m1-submodel-rating');
    let showHideButton = document.querySelector('#show-hide-button');
    
    for (let i = 0; i < previews.length; i++) {
        if (i > 5) {
            previews[i].classList.add('hidden-preview');
        }
    }

    $('.hidden-preview').wrapAll('<div id="hidden-previews" class="hidden-previews collapsible" />');
    
    if (showHideButton) {
        showHideButton.addEventListener('click', function(e) {
            e.preventDefault();
            var section = document.getElementById('hidden-previews');
            showHideButton.style.display = 'none';
            
            if (section.style.maxHeight){
                section.style.maxHeight = null;
            } else {
                section.style.maxHeight = 'max-content';
            }
        }); 
    }

    if (currentEdition == 'us' || currentEdition == 'ev_us') {
        getCBSWidget().then((api) => {
          api.cbsWidget();
        });
    }

		m1FindVehicleUs();
		m1FindVehicleEu();
		m1FindVehicleByType();
    $('.ss-slider').snapScrollControll();

    if ($("#about-make").length > 0) {
        // const hiddenArea = $("#about-make .browseBox > div");

        // $("#loadMore").on('click', function () {
        //     hiddenArea.css('max-height', hiddenArea.css('max-height') ===  '0px'
        //         ? hiddenArea.prop('scrollHeight') + 'px'
        //         : '0px');
        // });


        function updateBrowseBox() {
            const loadMoreBtn = document.getElementById('loadMore');
            const browseBox = document.querySelector('.browseBox');
            let isExpanded = false;
            const width = window.innerWidth;
            const selector = width > 767 ? ".browseBox > *:nth-child(n+4)" : ".browseBox > *:nth-child(n+2)";

                loadMoreBtn.addEventListener('click', () => {
                    isExpanded = !isExpanded;
                    
                    if (isExpanded) {
                    browseBox.querySelectorAll('.browseBox > *').forEach((p) => {
                        p.style.display = 'block';
                    });
                    // loadMoreBtn.textContent = 'hide';
                    } else {
                    browseBox.querySelectorAll(selector).forEach((p) => {
                        p.style.display = 'none';
                    });
                    // loadMoreBtn.textContent = 'leggi di più';
                    }
                });
        }

        updateBrowseBox();

        window.addEventListener("resize", updateBrowseBox);
    }
}